
import { Card } from "@/components/ui/card";
import { GymHeader } from "./GymHeader";
import { GymForm } from "./GymForm";

interface NewGymFormProps {
  gymName: string;
  gymAddress: string;
  onSave: (name: string, address: string, logoFile: File | null) => Promise<void>;
  onCancel: () => void;
}

export const NewGymForm = ({
  gymName,
  gymAddress,
  onSave,
  onCancel,
}: NewGymFormProps) => {
  return (
    <Card className="p-6">
      <GymHeader isNew />
      <GymForm
        gymId="new"
        gymName={gymName}
        gymAddress={gymAddress}
        isEditing={true}
        onSave={async (name, address, logoFile) => {
          await onSave(name, address, logoFile);
        }}
        onCancel={onCancel}
        onEdit={() => {}}
        onDelete={() => {}}
      />
    </Card>
  );
};
